// chakra imports
import { Flex, Stack, IconButton, Icon, useColorModeValue } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/LinksWithPermissions";
import { SIDEBAR_COLLAPSED_WIDTH } from "components/sidebar/components/CollapsedSidebarItem";
import React, { useContext } from "react";
import { SidebarContext } from "contexts/SidebarContext";
import { MdMenu, MdClose } from "react-icons/md";

// FUNCTIONS

function SidebarContent(props) {
  const { routes, collapsed, isDrawer = false } = props;
  const { setSidebarCollapsed } = useContext(SidebarContext);
  
  const toggleButtonColor = useColorModeValue("gray.600", "white");
  const toggleButtonBg = useColorModeValue("gray.100", "whiteAlpha.100");
  // SIDEBAR
  return (
    <Flex
      direction='column'
      pt={isDrawer ? '8px' : '25px'}
      pb='8px'
      px={collapsed ? 0 : "16px"}
      align={collapsed ? "center" : "stretch"}
      w={collapsed ? `${SIDEBAR_COLLAPSED_WIDTH}px` : '100%'}
      maxW={collapsed ? `${SIDEBAR_COLLAPSED_WIDTH}px` : '100%'}
      borderRadius='30px'
    >
      {!isDrawer && (
        <Flex justify={collapsed ? "center" : "flex-end"} mb="10px" flexShrink={0}>
          <IconButton
            aria-label="Toggle sidebar"
            icon={<Icon as={collapsed ? MdMenu : MdClose} />}
            onClick={() => setSidebarCollapsed(!collapsed)}
            size="sm"
            variant="ghost"
            color={toggleButtonColor}
            _hover={{ bg: toggleButtonBg }}
          />
        </Flex>
      )}

      <Brand collapsed={collapsed} compact={isDrawer} />
      <Stack
        direction='column'
        mt='8px'
        w={collapsed ? `${SIDEBAR_COLLAPSED_WIDTH}px` : '100%'}
        align={collapsed ? 'center' : 'stretch'}
        spacing={collapsed ? 0 : undefined}
      >
        <Links routes={routes} collapsed={collapsed} />
      </Stack>
    </Flex>
  );
}

export default SidebarContent;
